<template>

  <div class="app-main__outer" id="content-page-current">

    <div class="app-main__inner">

      <slot name="header"></slot>


      <div  v-if="hasBlackout" class="d-flex justify-content-center align-items-center" style="position: fixed; width: 100%; height: 100%; background-color: #FFFFFF; opacity: 0.5; z-index: 2" id="blackout">

        <div class="loader" style="scale: 1.5">
          <div class="ball-clip-rotate-multiple">
            <div></div>
            <div></div>
          </div>
        </div>


      </div>

      <div class="d-flex h-100-header justify-content-center align-items-center" v-if="hasLoadingPage">

        <div class="loader-wrapper">
          <div class="loader">
            <div class="ball-pulse-sync">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>


      </div>

      <div class="row" v-else id="page-content">
        <slot></slot>
      </div>

    </div>

    <slot name="footer"></slot>

  </div>

</template>

<script>
export default {
  name: "t-page",
  props: {},
  data() {
    return {
      //page: {}
    }
  },
  computed: {

    hasBlackout(){
      return this.$store.getters.getPageBlackoutShow
    },

    hasLoadingPage() {
      return this.$store.getters.getIsLoadingPage
    }

  }
}
</script>

<style>

</style>
